import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Auth from "./Auth";
import AuthFooter from "./AuthFooter";

const useStyles = makeStyles((theme) => ({
  section: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `radial-gradient(${theme.palette.primary.main}15 1px, transparent 1px)`,
      backgroundSize: "20px 20px",
      opacity: 0.3,
      zIndex: 0,
    },
  },
  container: {
    position: "relative",
    zIndex: 1,
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: "0 10px 50px rgba(0, 0, 0, 0.15)",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(145deg, rgba(30,30,30,0.98) 0%, rgba(20,20,20,0.98) 100%)"
        : "linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(245,245,245,0.98) 100%)",
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(5),
    },
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    letterSpacing: "-0.025em",
    marginBottom: theme.spacing(1),
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    textFillColor: "transparent",
    display: "inline-block",
  },
}));

function AuthSection(props) {
  const classes = useStyles();
  // Options by auth type
  const optionsByType = {
    signup: {
      // Top Title
      title: "Get yourself an account",
      // Button text
      buttonAction: "Sign up",
      // Footer text and links
      showFooter: true,
      signinText: "Already have an account?",
      signinAction: "Sign in",
      signinPath: "/auth/signin",
      // Terms and privacy policy agreement
      showAgreement: true,
      termsPath: "/legal/terms-of-service",
      privacyPolicyPath: "/legal/privacy-policy",
    },
    signin: {
      title: "Welcome back",
      buttonAction: "Sign in",
      showFooter: true,
      signupAction: "Create an account",
      signupPath: "/auth/signup",
      forgotPassAction: "Forgot Password?",
      forgotPassPath: "/auth/forgotpass",
    },
    forgotpass: {
      title: "Get a new password",
      buttonAction: "Reset password",
      showFooter: true,
      signinText: "Remember it after all?",
      signinAction: "Sign in",
      signinPath: "/auth/signin",
    },
    changepass: {
      title: "Choose a new password",
      buttonAction: "Change password",
    },
  };

  // Ensure we have a valid auth type
  const type = optionsByType[props.type] ? props.type : "signup";

  // Get options object for current auth type
  const options = optionsByType[type];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
      className={classes.section}
    >
      <Container maxWidth="xs">
        <Box className={classes.container}>
          <SectionHeader
            title={options.title}
            subtitle=""
            size={4}
            textAlign="center"
            className={classes.header}
            titleClassName={classes.title}
          />
          <Auth
            type={type}
            buttonAction={options.buttonAction}
            providers={props.providers}
            afterAuthPath={props.afterAuthPath}
            key={type}
          />

          {options.showFooter && <AuthFooter type={type} {...options} />}
        </Box>
      </Container>
    </Section>
  );
}

export default AuthSection;
